// AUTO-ESTRATTO da Bilancio.jsx (refactor strutturale Fase 10.03) — nessun cambio di logica/UI/testid.
import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { ModalShell, Field, Alert, Buttons, formatMln, formatMlnShort } from "./helpers";

export function AddMovementModal({ kinds, onClose, onCreated }) {
    const [kind, setKind] = useState(kinds[0]?.key || "");
    const [amount, setAmount] = useState("");
    const [description, setDescription] = useState("");
    const [teams, setTeams] = useState([]);
    const [teamId, setTeamId] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        api.get("/teams").then((r) => setTeams(r.data || [])).catch(() => {});
    }, []);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true); setErr("");
        try {
            const amt = Math.round(parseFloat(amount) * 1_000_000);
            if (!amt || amt <= 0) { setErr("Importo non valido"); setBusy(false); return; }
            await api.post("/treasury/movements", { kind, amount: amt, description, team_id: teamId || null });
            await onCreated();
        } catch (e) {
            setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <ModalShell onClose={onClose} title="Nuovo movimento" testid="add-movement-modal">
            <form onSubmit={submit} className="space-y-3">
                {err && <Alert text={err} />}
                <Field label="Tipo">
                    <select value={kind} onChange={(e) => setKind(e.target.value)} className="op-input w-full" data-testid="kind-select">
                        {kinds.map((k) => <option key={k.key} value={k.key}>{k.label} ({k.direction === "in" ? "+" : "−"})</option>)}
                    </select>
                </Field>
                <Field label="Importo (in milioni €)">
                    <input type="number" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} className="op-input w-full" placeholder="es. 0.5" data-testid="amount-input" />
                </Field>
                <Field label="Squadra (opzionale)">
                    <select value={teamId} onChange={(e) => setTeamId(e.target.value)} className="op-input w-full" data-testid="team-select">
                        <option value="">— nessuna —</option>
                        {teams.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
                    </select>
                </Field>
                <Field label="Descrizione">
                    <input type="text" value={description} onChange={(e) => setDescription(e.target.value)} className="op-input w-full" placeholder="es. Multa ritardo schiera" data-testid="desc-input" />
                </Field>
                <Buttons busy={busy} onClose={onClose} submitTestid="submit-movement" />
            </form>
        </ModalShell>
    );
}

export function FineModal({ onClose, onCreated }) {
    const [teams, setTeams] = useState([]);
    const [teamId, setTeamId] = useState("");
    const [amount, setAmount] = useState("");
    const [reason, setReason] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    useEffect(() => { api.get("/teams").then((r) => setTeams(r.data || [])).catch(() => {}); }, []);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true); setErr("");
        try {
            const amt = Math.round(parseFloat(amount) * 1_000_000);
            if (!amt || amt <= 0) { setErr("Importo non valido"); setBusy(false); return; }
            if (!teamId) { setErr("Seleziona una squadra"); setBusy(false); return; }
            if (!reason.trim()) { setErr("Inserisci la motivazione della multa"); setBusy(false); return; }
            await api.post("/treasury/fine", { team_id: teamId, amount: amt, reason: reason.trim() });
            await onCreated();
        } catch (e) {
            setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <ModalShell onClose={onClose} title="💸 Genera multa" testid="fine-modal">
            <form onSubmit={submit} className="space-y-3">
                {err && <Alert text={err} />}
                <p className="op-mono text-[11px] text-t8f95a3">L&apos;importo viene <strong className="text-tffffff">scalato dal budget della squadra</strong> e <strong className="text-tffffff">accreditato alla Cassa OP</strong>. Reversibile eliminando il movimento.</p>
                <Field label="Squadra">
                    <select value={teamId} onChange={(e) => setTeamId(e.target.value)} className="op-input w-full" data-testid="fine-team">
                        <option value="">— seleziona —</option>
                        {teams.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
                    </select>
                </Field>
                <Field label="Importo (in milioni €)">
                    <input type="number" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} className="op-input w-full" placeholder="es. 50" data-testid="fine-amount" />
                </Field>
                <Field label="Motivazione">
                    <input type="text" value={reason} onChange={(e) => setReason(e.target.value)} className="op-input w-full" placeholder="es. Ritardo ripetuto nell'invio del tabellino" data-testid="fine-reason" />
                </Field>
                <Buttons busy={busy} onClose={onClose} submitTestid="submit-fine" />
            </form>
        </ModalShell>
    );
}


export function UglyPurchaseModal({ onClose, onCreated }) {
    const [teams, setTeams] = useState([]);
    const [teamId, setTeamId] = useState("");
    const [amount, setAmount] = useState("");
    const [playerName, setPlayerName] = useState("");
    const [description, setDescription] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    useEffect(() => { api.get("/teams").then((r) => setTeams(r.data || [])).catch(() => {}); }, []);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true); setErr("");
        try {
            const amt = Math.round(parseFloat(amount) * 1_000_000);
            if (!amt || amt <= 0) { setErr("Importo non valido"); setBusy(false); return; }
            if (!teamId) { setErr("Seleziona una squadra"); setBusy(false); return; }
            await api.post("/treasury/ugly-purchase", { team_id: teamId, amount: amt, player_name: playerName || null, description });
            await onCreated();
        } catch (e) {
            setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <ModalShell onClose={onClose} title="Acquisto Ugly" testid="ugly-modal">
            <form onSubmit={submit} className="space-y-3">
                {err && <Alert text={err} />}
                <p className="op-mono text-[11px] text-t8f95a3">L&apos;importo viene scalato dal bilancio della squadra e accreditato a Cassa OP.</p>
                <Field label="Squadra">
                    <select value={teamId} onChange={(e) => setTeamId(e.target.value)} className="op-input w-full" data-testid="ugly-team">
                        <option value="">— seleziona —</option>
                        {teams.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
                    </select>
                </Field>
                <Field label="Importo (mln €)">
                    <input type="number" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} className="op-input w-full" placeholder="es. 2.5" data-testid="ugly-amount" />
                </Field>
                <Field label="Nome giocatore (opzionale)">
                    <input type="text" value={playerName} onChange={(e) => setPlayerName(e.target.value)} className="op-input w-full" placeholder="es. Mario Rossi" data-testid="ugly-name" />
                </Field>
                <Field label="Note">
                    <input type="text" value={description} onChange={(e) => setDescription(e.target.value)} className="op-input w-full" placeholder="opzionale" data-testid="ugly-desc" />
                </Field>
                <Buttons busy={busy} onClose={onClose} submitTestid="ugly-submit" />
            </form>
        </ModalShell>
    );
}

export function StadiumPaymentModal({ onClose, onCreated }) {
    const [tariff, setTariff] = useState(null);
    const [teams, setTeams] = useState([]);
    const [teamId, setTeamId] = useState("");
    const [upgradeKey, setUpgradeKey] = useState("level_1");
    const [kind, setKind] = useState("build");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        Promise.all([
            api.get("/treasury/stadium-tariff"),
            api.get("/teams"),
        ]).then(([a, b]) => { setTariff(a.data); setTeams(b.data || []); }).catch(() => {});
    }, []);

    const selectedAmount = tariff?.[upgradeKey]?.[kind === "build" ? "build_cost" : "annual_cost"] || 0;

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true); setErr("");
        try {
            if (!teamId) { setErr("Seleziona una squadra"); setBusy(false); return; }
            if (selectedAmount <= 0) { setErr("Questo upgrade non ha costo per il tipo selezionato"); setBusy(false); return; }
            await api.post("/treasury/stadium-payment", { team_id: teamId, upgrade_key: upgradeKey, kind });
            await onCreated();
        } catch (e) {
            setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <ModalShell onClose={onClose} title="Pagamento stadio" testid="stadium-modal">
            <form onSubmit={submit} className="space-y-3">
                {err && <Alert text={err} />}
                <Field label="Squadra">
                    <select value={teamId} onChange={(e) => setTeamId(e.target.value)} className="op-input w-full" data-testid="stadium-team">
                        <option value="">— seleziona —</option>
                        {teams.map((t) => <option key={t.id} value={t.id}>{t.name} (stadio Lv.{t.stadium_level ?? 0})</option>)}
                    </select>
                </Field>
                <Field label="Upgrade">
                    <select value={upgradeKey} onChange={(e) => setUpgradeKey(e.target.value)} className="op-input w-full" data-testid="stadium-upgrade">
                        {tariff && Object.entries(tariff).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
                    </select>
                </Field>
                <Field label="Tipo">
                    <select value={kind} onChange={(e) => setKind(e.target.value)} className="op-input w-full" data-testid="stadium-kind">
                        <option value="build">Costruzione (una tantum)</option>
                        <option value="maintenance">Manutenzione annuale</option>
                    </select>
                </Field>
                {tariff?.[upgradeKey] && (
                    <div className="op-mono text-[11px] text-t8f95a3 p-3 border border-t22252a">
                        <div>Importo: <strong className="text-tffffff">{formatMln(selectedAmount)}</strong></div>
                        <div className="mt-1">{tariff[upgradeKey].benefit}</div>
                    </div>
                )}
                <Buttons busy={busy} onClose={onClose} submitTestid="stadium-submit" />
            </form>
        </ModalShell>
    );
}

export function PayrollPreviewModal({ onClose }) {
    const [data, setData] = useState(null);
    const [err, setErr] = useState("");

    useEffect(() => {
        api.get("/treasury/payroll-preview").then((r) => setData(r.data)).catch((e) => setErr(e.message));
    }, []);

    return (
        <ModalShell onClose={onClose} title="Anteprima prelievo rata" testid="preview-modal" wide>
            {err && <Alert text={err} />}
            {!data && <div className="op-mono text-[11px] text-t8f95a3">Caricamento…</div>}
            {data && (
                <div>
                    <div className="op-mono text-[12px] mb-3">
                        Totale rata da prelevare: <strong className="text-t2bb6ff">{formatMln(data.total_installment_half)}</strong>
                    </div>
                    <div className="overflow-x-auto" style={{ maxHeight: "60vh" }}>
                        <table className="w-full text-[12px] op-mono">
                            <thead className="text-t8f95a3 sticky top-0 bg-t0e1014">
                                <tr>
                                    <th className="text-left py-1.5 px-2">Squadra</th>
                                    <th className="text-center py-1.5 px-1">Div</th>
                                    <th className="text-center py-1.5 px-1">VG11</th>
                                    <th className="text-right py-1.5 px-2">Base</th>
                                    <th className="text-right py-1.5 px-2">×VG11</th>
                                    <th className="text-right py-1.5 px-2">Dopo VG11</th>
                                    <th className="text-right py-1.5 px-2">×Div</th>
                                    <th className="text-right py-1.5 px-2">Annuo</th>
                                    <th className="text-right py-1.5 px-2 text-t2bb6ff">RATA ½</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.teams.map((t) => (
                                    <tr key={t.team_id} className="border-t border-t1a1d24">
                                        <td className="py-1.5 px-2 text-tffffff">{t.team_name}</td>
                                        <td className="text-center text-t8f95a3">{t.division_code || "—"}</td>
                                        <td className="text-center">{t.vg11_rounded ?? "—"}</td>
                                        <td className="text-right">{formatMlnShort(t.base)}</td>
                                        <td className="text-right text-te8ff00">{t.vg11_factor.toFixed(2)}</td>
                                        <td className="text-right">{formatMlnShort(t.after_vg11)}</td>
                                        <td className="text-right text-t2bb6ff">{t.division_factor.toFixed(2)}</td>
                                        <td className="text-right">{formatMlnShort(t.after_division)}</td>
                                        <td className="text-right text-t2bb6ff font-bold">{formatMlnShort(t.installment_half)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </ModalShell>
    );
}

// ---------- Reusable form bits ----------
